export function isConstructionLoan(productType: string) {
  return ['Fix and Flip', 'Ground Up Construction'].includes(productType)
}
